// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_rate_card_management_ui_styles" + "." + "610e181c" + ".chunk.css";
};